import { Stack, Typography } from '@mui/material';
import UserAvatar from './UserAvatar';
import { getUserProfileFullName } from '../../utils/users';
import React from 'react';
import { User } from '../../graphql/types';
import CustomTooltip from 'components/CustomTooltip';

interface UserInfoProps {
  user: User;
  showEmail?: boolean;
  useCompactViewStyle?: boolean | null;
  showBadge: boolean;
  isInvestor?: boolean;
}

function UserInfo({ user, useCompactViewStyle = false, showBadge = true, showEmail = true, isInvestor = false }: UserInfoProps) {
  const handleInvestorClick = () => {
    if (isInvestor && user?.id) {
      const path = `/portfolio/${user.id}`;
      window.open(path, '_blank');
    }
  };

  const clickableProps = isInvestor
    ? {
        onClick: handleInvestorClick,
        sx: { cursor: 'pointer' }
      }
    : {};
  const nameTypography = (
    <Typography
      variant="caption"
      sx={{
        fontSize: useCompactViewStyle ? '11px' : '13px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        lineHeight: 1.2
      }}
    >
      {getUserProfileFullName(user)}
    </Typography>
  );
  const userFullNameSection =
    isInvestor ? <CustomTooltip title={user?.email}>{nameTypography}</CustomTooltip> : nameTypography;
  const content = (
    <Stack direction="row" spacing={useCompactViewStyle ? 0.75 : 1.5} alignItems="center" {...clickableProps}>
      <Stack direction={'row'} spacing={useCompactViewStyle ? 0.75 : 1.5} mt={showEmail ? 1 : 0} justifyContent="start">
        <UserAvatar user={user} showBadge={showBadge} useCompactViewStyle={useCompactViewStyle} />
      </Stack>
      <Stack ml={1} spacing={useCompactViewStyle ? 0 : 0.5}>
        {userFullNameSection}
        {showEmail && (
          <Typography
            variant="caption"
            color="textSecondary"
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              lineHeight: 1.2
            }}
          >
            {user?.email}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
  return (!showEmail && !isInvestor) ? <CustomTooltip title={user?.email || ''}>{content}</CustomTooltip> : content;
}

export default UserInfo;
